// import UIkit
import UIkit from 'uikit';

// import JQUERY
import jQuery from "jquery";

// scrollbars lib
import "overlayscrollbars/js/jquery.overlayScrollbars";

// import video player
import Plyr from 'plyr';

// vue
import Vue from 'vue';
import axios from "axios";

// import sound lib
import {Howl} from "howler";

import './krpano/krpano';
// ready

jQuery(document).ready(function ($) {

    const DEVICE = window.device;
    const IS_MOBILE = DEVICE === 'mobile';
    const IS_TABLET = DEVICE === 'tablet';
    const IS_DESKTOP = DEVICE === 'desktop';

    const AUTOROTATE_AFTER_MILLISECONDS = 30 * 1000;

    Vue.config.devtools = true;

    const vueContainer = $('#vue-pano-app');

    if (vueContainer.length > 0) {
        new Vue({
            el: vueContainer[0],
            delimiters: ['${', '}'],
            mounted: function () {
                const me = this;
                me.initModals();
                me.initHistory();
                me.loadData();

                if (window.matchMedia) {
                    const mql = matchMedia("(max-width: 1024px), (max-height: 500px)");
                    const handler = function () {
                        if (mql.matches) {
                            $('body').removeClass('desktop').addClass('mobile');
                        } else {
                            $('body').addClass('desktop').removeClass('mobile');
                        }
                    }

                    mql.addEventListener("change", handler);
                    handler();
                } else {
                    $('body').addClass('desktop');
                }
            },
            data: {
                history: true,
                currentPageId: null,
                currentInfospotId: null,
                currentInfoPageId: null,
                pages: null,
                infoPages: null,
                krpano: null,
                currentSitePath: null,
                idleIval: null,
                idle: false,
                showInfo: false,
                tooltipX: 0,
                tooltipY: 0,
                tooltip: true,
                tooltipContent: '',
                roomAudio: null,
            },
            computed: {
                tooltipStyle: function() {
                    return {
                        left: this.tooltipX.toString() + 'px',
                        top: this.tooltipY.toString() - 55 + 'px',
                    }
                },
                isMobile: function () {
                    return IS_MOBILE
                },
                infospots: function () {
                    return this.pages.map(page => page.infospots).flat();
                },
                currentInfospot: function () {
                    if (this.currentInfospotId) {
                        return this.infospots.find(v => v.id === this.currentInfospotId);
                    }
                    return null;
                },
                currentPage: function () {
                    if (this.currentPageId && this.pages) {
                        return this.pages.find(v => v.id === this.currentPageId);
                    }
                    return null;
                },
                currentInfoPage: function () {
                    if (this.currentInfoPageId && this.infoPages) {
                        return this.infoPages.find(v => v.id === this.currentInfoPageId);
                    }
                    return null;
                },
                topPages: function () {
                    if (this.pages) {
                        return this.pages.filter(v => v.level === 1);
                    }
                    return null;
                },
                currentTopPage: function () {
                    if (this.currentPage) {
                        if (this.currentPage.parent) {
                            return this.pages.find(v => v.id === this.currentPage.parent);
                        }
                        return this.currentPage;
                    }
                    return null;
                },
                previousTopPage: function () {
                    if (!this.currentPage) return null;
                    let index = this.topPages.indexOf(this.currentTopPage);
                    if (index > 0) {
                        return this.topPages[index - 1];
                    }
                    return this.topPages[this.topPages.length - 1];
                },
                nextTopPage: function () {
                    if (!this.currentPage) return null;
                    let index = this.topPages.indexOf(this.currentTopPage);
                    if (index < this.topPages.length - 1) {
                        return this.topPages[index + 1];
                    }
                    return this.topPages[0];
                },
                previousPage: function () {
                    if (!this.currentPage) return null;
                    let index = this.pages.indexOf(this.currentPage);
                    if (index > 0) {
                        return this.pages[index - 1];
                    }
                    return this.pages[this.pages.length - 1];
                },
                nextPage: function () {
                    if (!this.currentPage) return null;
                    let index = this.pages.indexOf(this.currentPage);
                    if (index < this.pages.length - 1) {
                        return this.pages[index + 1];
                    }
                    return this.pages[0];
                }
            },
            watch: {
                idle: function (value) {
                    // this.viewer.OrbitControls.autoRotate = value;
                    // if (value) {
                    //     UIkit.modal(this.$refs.navigationModal).hide();
                    //     if (this.currentInfospot) {
                    //         this.navigate(this.currentPage, null, false);
                    //     }
                    // }
                },
                currentPage: function(value, oldValue) {
                    const me = this;

                    // change sound
                    if (value) {
                        me.playRoomSound();
                    }
                },
                currentPageId: function(value, oldValue) {
                    const me = this;
                    me.currentInfospotId = null;

                    // when page change, do following:

                    // 1. close navmodal
                    UIkit.modal(this.$refs.navigationModal).hide();

                    // 2. close infospots ?

                    // 3. change pano, if necessary
                    if (me.krpano) {
                        // if pano not already on page, make krpano change scene
                        const pageId = me.krpano.get('xml.scene').replace('scene-', '');
                        if (pageId !== me.currentPageId) {
                            me.krpano.call("gotoScene(scene-"+me.currentPageId+")");
                        }
                    }

                },
                currentInfoPageId: function(value, oldValue) {
                    const me = this;

                    this.currentInfospotId = null;
                    UIkit.modal(this.$refs.navigationModal).hide();

                    if (oldValue) {
                        let modal = me.$refs['infopage-modal-'+oldValue];
                        if (modal) {
                            UIkit.modal(modal).hide();
                        }
                    }

                    if (value) {
                        let modal = me.$refs['infopage-modal-'+value];
                        if (modal) {
                            UIkit.modal(modal).show();
                            $(modal).on("hide", function () {
                                me.currentInfoPageId = null;
                            });
                        }
                    }
                },
                currentInfospotId: function(value, oldValue) {
                    const me = this;

                    if (oldValue) {
                        let hotspot = me.getHotspotById(oldValue);
                        if (hotspot) {
                            UIkit.modal(hotspot.modal).hide();
                        }
                    }

                    if (value) {
                        let hotspot = me.getHotspotById(value);
                        if (hotspot) {
                            UIkit.modal(hotspot.modal).show();
                        }
                    }
                }
            },
            methods: {

                playRoomSound() {
                    const me = this;

                    if (me.roomAudio) {
                        me.roomAudio.stop();
                    }

                    if (me.currentPage && me.currentPage.audio) {
                        me.roomAudio = new Howl({
                            src: [me.currentPage.audio],
                            loop: true,
                            html5: true,
                            volume: 0.5,
                        });
                        me.roomAudio.play();
                    }
                },
                resetView: function() {
                    const me = this;
                    if (me.krpano) {
                        me.krpano.call("reset_view()");
                    }
                },
                openInfoPage: function (id) {
                    this.currentInfoPageId = id;
                },
                getPageById: function(id) {
                    return this.pages.find(v => v.id === id);
                },
                getHotspotById: function(id) {
                    let array = this.pages.map(v => v.infospots).flat();
                    return array.find(v => v.id === id);
                },
                initTouchEvents: function () {
                    $('body').on('touchstart', function (event) {
                        $('body').addClass('touch');
                    });
                    $("canvas.panolens-canvas").on('touchstart', function () {
                        $('body').addClass('touch');
                    });
                },
                setShowInfo: function (value) {
                    this.showInfo = value;
                },
                initModals: function () {
                    const me = this;
                    const contentArea = me.$refs['contentArea'];

                    UIkit.util.on('.uk-modal-full', 'shown', function (evt) {
                        // do something

                        const modal = evt.target;

                        $(contentArea).css('opacity', 0);

                        const screenWidth = $(window).width();
                        const screenHeight = $(window).height();

                        if (screenWidth < 1023) {
                            const modalPictureHeight = $('.modal-picture', modal).outerHeight();
                            const modalTitleHeight = $('.modal-title', modal).outerHeight() + 20;
                            const modalTextHeight = screenHeight - modalPictureHeight - modalTitleHeight - 200;
                            $('.modal-text', modal).height(modalTextHeight);
                        }
                    });

                    UIkit.util.on('.uk-modal-full', 'hide', function () {
                        $(contentArea).css('opacity', 1);
                    });
                },
                childPages: function (page) {
                    return this.pages.filter(v => v.parent === page.id);
                },
                loadData: function () {
                    const me = this;

                    me.currentPageId = this.$refs.vueCurrentPage.value;
                    me.currentInfospotId = this.$refs.vueCurrentInfospot.value;
                    me.currentSitePath = this.$refs.vueCurrentSitePath.value;

                    axios.get(this.currentSitePath + 'pages.json?device=' + DEVICE).then(
                        result => {
                            this.pages = result.data.data;
                            this.createKrpano();
                            //this.navigate(this.currentPage, this.currentInfospot, true);
                        }
                    );

                    axios.get(this.currentSitePath + 'info-pages.json?device=' + DEVICE).then(
                        result => {
                            this.infoPages = result.data.data;
                        }
                    );
                },
                initIdleHandlers: function () {
                    // const me = this;
                    //
                    // $(document).on('mousemove', function (event) {
                    //     me.unsetIdle();
                    // });
                    //
                    // if (IS_MOBILE) {
                    //     $('canvas.panolens-canvas').on('touchstart', function () {
                    //         me.unsetIdle();
                    //     });
                    // }
                    //
                    // me.idleIval = setTimeout(this.setIdle, AUTOROTATE_AFTER_MILLISECONDS);
                },
                unsetIdle: function () {
                    // if (this.idleIval) {
                    //     clearInterval(this.idleIval);
                    //     this.idleIval = null;
                    // }
                    // this.idle = false;
                    // this.idleIval = setTimeout(this.setIdle, AUTOROTATE_AFTER_MILLISECONDS);
                },
                setIdle: function () {
                    // this.idle = true;
                },
                // onPanoramaProgress: function (event) {
                //     const progressBar = this.$refs.progressbar;
                //     const percentage = event.progress.loaded / event.progress.total * 100;
                //
                //     progressBar.style.width = percentage + "%";
                //     if (percentage >= 100) {
                //         progressBar.classList.add('hide');
                //         setTimeout(function () {
                //             progressBar.style.width = 0;
                //         }, 1000);
                //     }
                // },

                initHistory: function()
                {
                    const me = this;

                    window.onpopstate = function (event) {
                        if (event.state) {
                            let page = me.pages.find(v => v.id === event.state.page);
                            let infospot = me.infospots.find(v => v.id === event.state.infospot);

                            me.history = false;
                            me.navigateTo(page, infospot);
                        }
                    }
                },


                /**
                 * Helper function for templates pages
                 * @param page
                 * @param infospot
                 */
                navigateTo: function(page, infospot)
                {
                    const me = this;

                    const pageChanged = page.id !== me.currentPageId
                    const infospotChanged =
                        (infospot && infospot.id !== me.currentInfospotId)
                        ||
                        (!infospot && me.currentInfospotId);
                    const isChanged = pageChanged || infospotChanged;

                    me.currentPageId = page.id;
                    me.currentInfospotId = infospot ? infospot.id : null;

                    if (isChanged && me.history) {

                        let url = this.currentPage.url;
                        if (this.currentInfospot) {
                            url += '?info=' + this.currentInfospot.id;
                        }

                        window.history.pushState({
                            page: this.currentPageId,
                            infospot: this.currentInfospotId
                        }, this.currentPage.title, url);
                    }
                    me.history = true;
                },

                /**
                 * Helper function for templates pages
                 * @param infospot
                 */
                openInfospot: function(infospot) {
                    this.currentInfospotId = infospot.id;
                },

                navigate: function (pageId, infospot = null, pushHistory = true) {
                    alert('DEPRECATED');
                    return;

                    const me = this;
                    const page = me.pages.find(page => page.id === pageId);

                    UIkit.modal(this.$refs.navigationModal).hide();

                    // check if infospot is actually link to another page/panorama

                    if (infospot && infospot.page_id) {
                        let targetPage = me.pages.find(v => v.id === infospot.page_id);
                        return me.navigate(targetPage, null, pushHistory);
                    }

                    // if page, set pano

                    if (page) {
                        // this.viewer.setPanorama(page.panorama);
                        this.currentPageId = page.id;
                    }

                    // hide prev modal, show modal if infospot

                    if (this.currentInfospot) {
                        UIkit.modal(this.currentInfospot.modal).hide();
                    }

                    if (infospot) {
                        UIkit.modal(infospot.modal).show();

                        infospot.modal.one("beforehide", function () {
                            me.navigate(me.currentPage, null, true);
                        });

                        this.currentInfospotId = infospot.id;
                    } else {
                        this.currentInfospotId = null;
                    }

                    // history

                    if (pushHistory === true) {
                        let url = this.currentPage.url;
                        if (this.currentInfospot) {
                            url += '?info=' + this.currentInfospot.id;
                        }

                        window.history.pushState({
                            page: this.currentPageId,
                            infospot: this.currentInfospotId
                        }, this.currentPage.title, url);
                    }
                },
                createKrpano() {
                    const me = this;

                    embedpano({
                        xml: me.currentSitePath + "/krpano.xml",
                        target: "panoContainer",
                        swf: null,
                        html5: "auto",
                        onready: function (krpano) {
                            me.krpano = krpano;
                            me.krpano.call("gotoScene(scene-"+me.currentPageId+")");

                            me.krpano.set("events.onnewscene", function () {
                                const page = me.getPageById(me.krpano.get('xml.scene').replace('scene-', ''));
                                me.navigateTo(page);
                            });

                            window.onHotspotClick = function(blockId) {
                                const infospot = me.getHotspotById(blockId.replace('hotspot-',''));
                                if (infospot) {
                                    me.navigateTo(me.currentPage, infospot);
                                }
                            }
                            window.onHotspotOver = function(blockId) {
                                const infospot = me.getHotspotById(blockId.replace('hotspot-',''));
                                me.tooltipContent = infospot.title;
                                me.tooltip = true;
                            }
                            window.onHotspotOut = function(blockId) {
                                me.tooltip = false;
                            }
                            window.onHotspotHover = function(blockId) {
                                me.tooltipX = krpano.get("mouse.x");
                                me.tooltipY = krpano.get("mouse.y");
                            }
                        }
                    });

                    for (let page of this.pages) {
                        for (let infospot of page.infospots) {
                            infospot.modal = $(me.$refs['infospot-modal-' + infospot.id]);

                            $(infospot.modal).on('hide.uk.modal', function() {
                                me.navigateTo(me.currentPage);
                            });
                        }
                    }

                    this.initIdleHandlers();
                    this.initTouchEvents();
                }
            }
        });
    }

    const aframeContainer = $('#aframe-app');

    if (aframeContainer.length > 0) {

    }

    $('[data-overlay-scrollbars]').overlayScrollbars({});

    // VIMEO: stop video playing when slide change, or modal close...

    let resetEmbeddedIFrames = function (parent) {
        $('.si-video iframe', parent).each(function () {
            $(this).attr('src', $(this).attr('src'));
        });
    }

    $('ul.uk-slider-items > li').on('itemhide', function () {
        resetEmbeddedIFrames(this);
    });

    $('div.uk-modal').on('hide', function () {
        resetEmbeddedIFrames(this);
    });

    // PLYR

    Plyr.setup('.video-player');

    let resetPlyr = function(parent) {
        $('video', parent).each(function () {
            this.plyr.stop();
        });
    }

    $('ul.uk-slider-items > li').on('itemhide', function () {
        resetPlyr(this);
    });

    $('div.uk-modal').on('hide', function () {
        resetPlyr(this);
    });
});

export {jQuery, UIkit};